<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-grid>
      <cv-row>
        <cv-column :sm="4" :md="6" :lg="16">
          <cv-combo-box label="" title="Materiali"
                        :auto-filter="true"
                        v-model="modello_materiale"
                        :options="materiali"></cv-combo-box>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="6" :lg="16">
          <cv-tile style="margin-top: 0.5em; margin-bottom: 0.5em;">
            <h6>Scorta Minima</h6>
            <cv-radio-group :vertical="true"
                            title="Scorta Minima" >
              <cv-radio-button name="scorta"
                               label="Tutti"
                               value="1"
                               v-model="modello_scorta_minima" />
              <cv-radio-button name="scorta"
                               label="Solo Sotto"
                               value="2"
                               v-model="modello_scorta_minima" />
              <cv-radio-button name="scorta"
                               label="Uguale e Sopra"
                               value="3"
                               v-model="modello_scorta_minima" />
            </cv-radio-group>
          </cv-tile>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="6" :lg="16">
          <cv-tile style="margin-top: 0.5em; margin-bottom: 0.5em;">
            <h6>Destinazione alle Macchine</h6>
            <cv-radio-group :vertical="true"
                            title="Destinazione alle Macchine" >
              <cv-radio-button name="dest"
                               label="Tutti"
                               value="1"
                               v-model="modello_destinazione" />
              <cv-radio-button name="dest"
                               label="Solo Destinati"
                               value="2"
                               v-model="modello_destinazione" />
              <cv-radio-button name="dest"
                               label="Solo non Destinati"
                               value="3"
                               v-model="modello_destinazione" />
            </cv-radio-group>
          </cv-tile>
        </cv-column>
      </cv-row>
    </cv-grid>

    <cv-grid >
      <cv-row>
        <cv-column :sm="4" :md="4" :lg="8">
          <h6 style="text-align: left">Quantità Utilizzata</h6>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="3" :lg="8">
          <data-valida etichetta="Dalla Data"
                       v-model="parametri.dalla_data"
                       messaggio_non_valido="Data iniziale non valida" />
        </cv-column>
        <cv-column :sm="4" :md="3" :lg="8">
          <data-valida etichetta="Alla Data"
                       v-model="parametri.alla_data"
                       messaggio_non_valido="Data finale non valida" />
        </cv-column>
      </cv-row>
    </cv-grid>

    <hr/>
    <BottonieraRicerche v-on:filtra-premuto="$emit('bottone-premuto')"
                        v-on:pdf-premuto="$emit('bottone-premuto')" />
  </cv-content>
</template>

<script>
import BottonieraRicerche from "@/components/BottonieraRicerche";

export default {
  name: "RicercaMacchine",
  components: { BottonieraRicerche },
  data: function() {
    return {
      parametri: {
        dalla_data: "",
        alla_data: ""
      },
      modello_materiale: "",
      modello_scorta_minima: "1",
      modello_destinazione: "1",
      materiali: [
        {
          value: "1",
          label: "OLIO AGIP",
          name: "1"
        },
        {
          value: "2",
          label: "BULLONI",
          name: "2"
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>